export default {
  data() {
    return {
      signupNoticeId: this.$route.query.signupNoticeId,
      signupData: null
    };
  },
  created() {
    if (!this.signupNoticeId) {
      this.$router.push('index');
    } else {
      // this.getNewNoticeById();
    }
  },
  methods: {
    async getNewNoticeById() {
      // 根据报名通知ID查询报名须知 #李茹钰/2019-03-14#
      this.$message.loading();
      let { data } = await this.$ajax.gateway('/bm/ISignupNoticeApi_getNoticeProtocol', {
        signupNoticeId: this.signupNoticeId
      });
      if (data.code === 200 && typeof data.data === 'object') {
        this.$message.hide();
        data = data.data;
        this.signupData = data;
      } else {
        this.$router.push('/index');
      }
    },
    async ajaxCheckIdCard(params, formVal) {
			// params.SKIP_MESSAGE = true;
      // 校验学生身份证号码是否已报名 #李茹钰/2019-03-12#
      let { error, data } = await this.$ajax.gateway('/bm/IStudentSignupApi_checkIdCard', params);
			console.log('-> 校验学生身份证号码是否已报名', data);
			// if (error && error.data) {
			// 	console.log('error', error);
			// 	this.$message.error(error.data.message);
			// 	return false;
			// }
      // 清除缓存
      sessionStorage.removeItem('signupForm');
      if (!error && data.code === 200) {
        if (data.data) {
          console.log('-> 该学生身份证号码已经报名了', data.data);
          this.$message.warning('该学生身份证号码已经报过名了！');
        } else {
          console.log('-> 该学生身份证号码还没有报过名', data.data);
          // 添加缓存
          sessionStorage.setItem('signupForm', JSON.stringify(formVal));
          sessionStorage.removeItem('autoPushStep');
          this.$router.push({
            path: 'bm_form',
            query: {
              // studentHouseType: formVal.studentHouseType,
              studentApplyType: formVal.studentApplyType,
              signupNoticeId: this.signupNoticeId
            }
          });
        }
      }
    }
  }
};
